import { render, staticRenderFns } from "./MFolderTagsSection.vue?vue&type=template&id=1afb0b5e&scoped=true&"
import script from "./MFolderTagsSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MFolderTagsSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MFolderTagsSection.vue?vue&type=style&index=0&id=1afb0b5e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb0b5e",
  null
  
)

export default component.exports